import { localStorage as local } from '@entrata/utils'
import { LOGIN_FROM_ENTRATA } from 'portal-modules/common/constants/keys'

export default data =>
  'true' == local.get(LOGIN_FROM_ENTRATA)
    ? {
        ...data,
        login_from_entrata: true,
      }
    : data
